import React from 'react';
import {StyleSheet, View} from 'react-native';
import Toast from 'react-native-toast-message';
import {faCheck} from '@fortawesome/free-solid-svg-icons/faCheck';
import {faXmark} from '@fortawesome/free-solid-svg-icons/faXmark';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

import theme from '../style/theme';

import Text from './ui-controls/Text';

export const SUCCESS_CHECK = 'successCheck';
export const ERROR_MESSAGE = 'errorMessage';
export const PASSWORD_RESET_REQUEST = 'passwordResetRequest';
export const SUCCESS_TEXT = 'successText';

const config = {
  [SUCCESS_CHECK]: () => (
    <View style={styles.successOuter}>
      <FontAwesomeIcon icon={faCheck} size={48} style={styles.icon} />
    </View>
  ),
  [PASSWORD_RESET_REQUEST]: () => (
    <View style={styles.container}>
      <View style={styles.check}>
        <FontAwesomeIcon icon={faCheck} size={48} style={styles.icon} />
      </View>
      <View style={styles.right}>
        <Text style={styles.text}>
          An email with a reset link has been sent.
        </Text>
      </View>
    </View>
  ),
  [ERROR_MESSAGE]: ({text1, text2}: {text1: string; text2: string}) => {
    return (
      <View style={styles.container}>
        <View style={styles.check}>
          <FontAwesomeIcon icon={faXmark} size={48} style={styles.iconAlt} />
        </View>
        <View style={styles.right}>
          <Text style={styles.text}>{text1}</Text>
          {!!text2 && <Text style={styles.text}>{text2}</Text>}
        </View>
      </View>
    );
  },
  [SUCCESS_TEXT]: ({text1}: {text1: string}) => (
    <View style={styles.container}>
      <View style={styles.check}>
        <FontAwesomeIcon icon={faCheck} size={48} style={styles.icon} />
      </View>
      <View style={styles.right}>
        <Text style={styles.text}>{text1}</Text>
      </View>
    </View>
  ),
};

type ToastBottomProps = {
  type?: string;
  visibilityTime?: number;
  onHide?: () => void;
};

const ToastBottom = ({
  type = 'successCheck',
  visibilityTime = 4000,
  onHide = () => {},
}: ToastBottomProps) => (
  <Toast
    type={type}
    config={config}
    position="bottom"
    onPress={Toast.hide}
    visibilityTime={visibilityTime}
    onHide={onHide}
  />
);

const styles = StyleSheet.create({
  successOuter: {
    backgroundColor: theme.colour.general.primary,
    padding: 20,
    borderRadius: 48,
  },
  icon: {
    color: theme.colour.icon.general.secondary,
  },
  iconAlt: {
    color: theme.colour.general.highlight,
  },
  container: {
    borderWidth: 0.5,
    borderColor: 'grey',
    width: '80%',
    padding: 8,
    backgroundColor: 'white',
    borderRadius: 8,
    borderLeftWidth: 8,
    borderLeftColor: theme.colour.border.general.primary,
    flexDirection: 'row',
  },
  check: {
    backgroundColor: theme.colour.icon.general.primary,
    padding: 4,
    borderRadius: 48,
    marginRight: 16,
    alignSelf: 'center',
  },
  right: {
    flex: 1,
    justifyContent: 'center',
  },
  text: {
    fontSize: 16,
  },
});

export default ToastBottom;
